let apiEntryPoint = "";

const origin = window.location.origin;

if (process.env.NODE_ENV == "development") {
    apiEntryPoint = `${origin}/api`;
} else {
    const path = window.parent.location.pathname.split("/")[1];

    apiEntryPoint = `${origin}/${path}/api`;
}

// adding version info
apiEntryPoint += "/v2";

console.log("CLink api entry point: ", apiEntryPoint);

export const DebugEndpoint = `${apiEntryPoint}/debug`;
const EntryPoint = `${apiEntryPoint}`;
export default EntryPoint;
